var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCouponPc = function SvgCouponPc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 54 54"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "CouponPc_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0,
    d: "M12 12h30v30H12z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "#402C22",
    opacity: 0.6,
    rx: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#CouponPc_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M14.5 15.75h25v7.5c-2.08 0-3.75 1.67-3.75 3.75 0 2.07 1.67 3.75 3.75 3.75v7.5h-25v-7.5c2.07 0 3.75-1.68 3.75-3.75 0-2.08-1.68-3.75-3.75-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinejoin: "round",
    d: "M39.5 15.75v7.5c-2.08 0-3.75 1.67-3.75 3.75 0 2.07 1.67 3.75 3.75 3.75v7.5h-25v-7.5c2.07 0 3.75-1.68 3.75-3.75 0-2.08-1.68-3.75-3.75-3.75v-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4F3526",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m23.25 30.75 7.5-7.51"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.25,
    cy: 23.25,
    r: 1.25,
    fill: "#6D482E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.75,
    cy: 30.75,
    r: 1.25,
    fill: "#6D482E"
  }))));
};
export default SvgCouponPc;